<template>
	<div class="carousel-section">
		<div
			class="carousel-wrapper"
			v-if="providers.length"
		>
			<div
				class="carousel-body"
				:class="{ center: providers.length < 4 }"
			>
				<div
					class="carousel-item"
					v-for="(data, ind) in providers"
					:key="`provider-card-item-${ind}`"
				>
					<provider-card
						:data="data"
						:campaign-data="campaignData"
					/>
				</div>
			</div>
		</div>
		<slot></slot>
	</div>
</template>
<script>
import ProviderCard from './ProviderCard.vue';

export default {
	name: 'Carousel',
	props: {
		providers: {
			type: Array,
			default: () => [],
		},
		campaignData: {
			type: Object,
			default: null,
		},
	},
	components: {
		ProviderCard,
	},
};
</script>
<style lang="scss" scoped>
.carousel-section {
	.carousel-wrapper {
		width: 100%;
		padding: 24px 0 26px 0;
		overflow-x: hidden;

		@media screen and (max-width: 1024px) {
			padding: 16px 0 20px 0;
		}

		@media screen and (max-width: 767px) {
			padding: 20px 0 16px 0;
		}

		@media screen and (min-width: 992px) {
			/* width */
			::-webkit-scrollbar {
				height: 8px;
			}

			/* Track */
			::-webkit-scrollbar-track {
				background: transparent;
			}

			/* Handle */
			::-webkit-scrollbar-thumb {
				background: rgba(0, 0, 0, 0.25);
				border-radius: 4px;
			}

			/* Handle on hover */
			::-webkit-scrollbar-thumb:hover {
				background: rgba(0, 0, 0, 0.5);
			}
		}

		.carousel-body {
			display: flex;
			column-gap: 20px;
			scroll-snap-type: x mandatory;
			flex-direction: row;
			overflow-x: auto;

			@media screen and (max-width: 1024px) {
				column-gap: 15px;
			}

			@media screen and (max-width: 767px) {
				column-gap: 12px;
			}

			@media screen and (min-width: 768px) {
				&.center {
					justify-content: center;
				}
			}

			.carousel-item {
				width: 100%;
				scroll-snap-align: center;
				padding: 5px 0;
				flex: 0 0 325px;
				max-width: 325px;

				&:last-child {
					margin-right: 20px;
				}

				&:first-child {
					margin-left: 20px;
				}

				@media screen and (max-width: 1024px) {
					flex: 0 0 220px;
					max-width: 220px;
				}

				@media screen and (max-width: 767px) {
					flex: 0 0 254px;
					max-width: 254px;
				}
			}
		}
	}
}
</style>
